export default "__VITE_ASSET__C4J3T_6p__"